import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 34 * 60 + 39);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
  description?: string;
}
export function Pricing({
  showAnchor = false,
  description = 'Todo el sistema en PDF + 5 herramientas prácticas para implementar lo aprendido.'
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-surface" data-id="element-112" data-mp="3h6bkdzqf5tz4">
      <div className="bg-urgency-surface px-4 py-16 sm:py-20" data-id="element-113" data-mp="3c8tfckfivywe">
        <div className="mx-auto max-w-4xl text-center" data-id="element-114" data-mp="3canxjqzetcws">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-115" data-mp="3vyni0e3ddvae">
            💰 PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" role="timer" aria-label={`${hours} horas, ${minutes} minutos, ${seconds} segundos`} data-id="element-116" data-mp="4v8l4o0swffy">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-117" data-mp="3d9h73d8ti7z5" data-mpi={index}>
                <div data-id="element-118" data-mp="3dailnrp1lclm">
                  <p className="font-display text-5xl font-bold tabular-nums text-danger sm:text-7xl" data-id="element-119" data-mp="3d6us4sjlkq6w">
                    {value}
                  </p>
                  <p className="text-xs tracking-spaced text-foreground-subtle" data-id="element-120" data-mp="3n63r5ztbkv04">
                    {label}
                  </p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-danger sm:text-6xl" aria-hidden="true" data-id="element-121" data-mp="2uihgk7locq3r">
                    :
                  </span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-foreground-subtle" data-id="element-122" data-mp="2rgv1tjl906gd">
            Después sube. <b className="text-foreground" data-id="element-123" data-mp="2rf1t7yr2rc5q">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-danger/20 bg-canvas p-4 text-left" data-id="element-124" data-mp="2mgqjrp4oz3o1">
            <div className="flex justify-between text-sm font-medium text-danger-soft" data-id="element-125" data-mp="315cxxnil1pdo">
              <span data-id="element-126" data-mp="2w8mj13iikztu">Precio de lanzamiento</span>
              <span data-id="element-127" data-mp="2w9xl8ywb9ziu">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-track" data-id="element-128" data-mp="28is5skua9992">
              <div className="h-full w-[80%] rounded-full bg-danger" data-id="element-129" data-mp="23jpb9ubxilfc" />
            </div>
            <p className="mt-2 text-right text-xs text-foreground-faint" data-id="element-130" data-mp="2igpsv50ep003">
              Cupos disponibles al precio de lanzamiento
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 py-16 sm:py-24" data-id="element-131" data-mp="3tvbpbpk91yli">
        <div className="mx-auto max-w-2xl" data-id="element-132" data-mp="3tu0mpt2jiwvz">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-133" data-mp="3tx6a93vitqpl">
            🌿 TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-primary bg-canvas p-6 shadow-featured sm:p-9" data-id="element-134" data-mp="a43xsc3ewpg">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-135" data-mp="3rgeyd5mlkz7t">
              <div data-id="element-136" data-mp="3rihwkcxwlynm">
                <h3 className="font-display text-lg font-bold text-primary-soft" data-id="element-137" data-mp="j0d4yyw58ifk">
                  KIT SIMPLIFICACIÓN INTEGRAL™
                </h3>
                <p className="mt-1 text-sm text-foreground-subtle" data-id="element-138" data-mp="nz6kewuzqjid">
                  5 volúmenes + 5 bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-primary-soft" data-id="element-139" data-mp="e9wp784uokq1">
                  {description}
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-140" data-mp="11yxuimidzfr3">
                <p className="text-xs uppercase tracking-wider text-foreground-faint" data-id="element-141" data-mp="16q7h1e8n22yr">
                  Precio original
                </p>
                <p className="text-foreground-faint line-through" data-id="element-142" data-mp="3f8bjwnq1pjw5">$65.000</p>
                <p className="mt-2 text-xs uppercase tracking-wider text-primary-soft/70" data-id="element-143" data-mp="3a85yhpadctmi">
                  Precio lanzamiento
                </p>
                <p className="font-display text-4xl font-bold text-primary-soft" data-id="element-144" data-mp="35bf7i6x10dmb">
                  $19.990
                </p>
                <p className="text-xs text-foreground-subtle" data-id="element-145" data-mp="1sm60shivf8i">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-146" data-mp="3syncsougfmoc">
            🌿 QUIERO MI KIT DE SIMPLIFICACIÓN
          </ActionButton>
        </div>
      </div>
    </section>;
}